import { Observable, observable } from "@legendapp/state";

type Status = "loading" | "loaded" | "success" | "error";
type FetchStatus = "fetching" | "idle" | "paused";

export class StatusManager {
  public status: Observable<Status>;
  public fetchStatus: Observable<FetchStatus>;

  constructor() {
    this.status = observable<Status>("loading");
    this.fetchStatus = observable<FetchStatus>("idle");
  }

  public setStatus(status: Status) {
    this.status.set(status);
  }

  public setFetchStatus(status: FetchStatus) {
    this.fetchStatus.set(status);
  }

  public isFetching() {
    return this.fetchStatus.peek() === "fetching";
  }

  public isLoading() {
    return this.status.peek() === "loading";
  }

  public isLoaded() {
    return this.status.peek() === "loaded";
  }

  public isIdle() {
    return this.fetchStatus.get() === "idle";
  }

  public isPaused() {
    return this.fetchStatus.get() === "paused";
  }

  public isInitialLoading() {
    return this.isLoading() && this.isFetching();
  }

  public isFetchingOrPaused() {
    return this.isFetching() || this.isPaused();
  }

  public isFetchingOrIdle() {
    return this.isFetching() || this.isIdle();
  }

  public isLoadedOrFetching() {
    return this.isLoaded() || this.isFetching();
  }

  public isLoadedOrIdle() {
    return this.isLoaded() || this.isIdle();
  }
}
